<div class="grid grid-cols-12 h-full bg-grey-lightest p-8">
	<!-- Main Content Area -->
	<div
		class="flex flex-col h-full overflow-auto pr-6"
		[ngClass]="
			!((enabledDocumentFlow$ | async) === MatterDocumentFlows.LEAP)
				? 'col-span-9'
				: 'col-span-12'
		"
	>
		<!-- Header Section -->
		<header class="flex items-center">
			<h2 class="my-2">Documents</h2>
			<div class="flex ml-3 relative">
				<app-button
					class="flex justify-center items-center bg-green text-green-lightest rounded-md py-1"
					(click)="toggleDropdown()"
					(clickOutside)="hideDropdown()"
					data-intercom-target="add-document-folder"
					[icon]="ICON.ADD"
					size="small"
					btn="clear"
				>
					New
				</app-button>

				<app-dropdown-options
					[show]="showDropdownOptions"
					[itemGroups]="[
						{
							items:
								(enabledDocumentFlow$ | async) === MatterDocumentFlows.LEAP
									? leapDocumentDropdownOptions
									: documentDropdownOptions,
						},
					]"
					(onSelect)="onDropdownAction($event)"
					xposition="right"
				/>
			</div>
		</header>

		<!-- Action Buttons Section -->
		<ng-container
			*ngIf="!((enabledDocumentFlow$ | async) === MatterDocumentFlows.LEAP)"
		>
			<div class="flex items-center gap-2 my-3 text-lg">
				<ng-container *ngIf="highlightedDocumentIds$ | async as highlightedIds">
					<ng-container
						[ngTemplateOutlet]="
							highlightedIds.length ? tplActionButtons : tplShowSelectionTip
						"
						[ngTemplateOutletContext]="{ highlightedIds: highlightedIds }"
					>
					</ng-container>
				</ng-container>
			</div>
		</ng-container>

		<!-- Search Toolbar -->
		<div
			class="flex justify-between items-center bg-white p-6 rounded-t-xl border border-grey-lighter border-b-0"
		>
			<h3>In File Documents</h3>
			<div class="flex grow max-w-350">
				<app-input
					[startIcon]="ICON.SEARCH"
					[endIcon]="searchText ? ICON.CLOSE : null"
					[(ngModel)]="searchText"
					(endItemClick)="searchText = ''"
					placeholder="Search in file documents..."
					type="text"
				/>
			</div>
		</div>

		<!-- HTML Document Tree -->
		<app-document-tree
			#documentTree
			*ngIf="!(areDocumentsAndFoldersLoading$ | async)"
			[authors]="AuthorIds$ | async"
			[documents]="documents$ | async"
			[folders]="folders$ | async"
			[filter]="searchText"
			[mode]="documentTreeMode"
			[root]="true"
			[showHeaders]="true"
			[showTypeTags]="false"
			[showVersions]="false"
			[sortBy]="sortBy"
			[sortOrder]="sortOrder"
			(addDocumentFromTemplate)="addDocument(false, $event)"
			(addBlankDocument)="addDocument(true, $event)"
			(addFolder)="addFolder($event)"
			(copyDocument)="copyDocument($event)"
			(deleteDocument)="deleteDocument($event)"
			(deleteFolder)="deleteFolder($event)"
			(editDocument)="editDocument($event)"
			(editFolder)="editFolder($event)"
			(moveDocument)="moveDocument($event)"
			(moveDocumentsToFolder)="moveDocumentsToFolder($event)"
			(resetDocument)="resetDocument($event)"
			(selectedDocuments)="updateSelectedDocuments($event)"
			(sortChange)="onSortChange($event)"
			class="overflow-y-hidden"
		/>
	</div>

	<!-- Template Sidebar -->
	<ng-container
		*ngIf="!((enabledDocumentFlow$ | async) === MatterDocumentFlows.LEAP)"
	>
		<app-template-sidebar
			class="h-full w-full col-span-3 overflow-auto"
			[folderId]="''"
			(createDocumentFromTemplate)="checkForContext($event)"
		/>
	</ng-container>
</div>

<!-- Templates -->
<ng-template #tplActionButtons let-highlightedIds="highlightedIds">
	<app-button
		btn="tertiary"
		size="small"
		(click)="onDeselectAllClick()"
		intercomAttr="documents-deselect-all-button"
	>
		Deselect all
	</app-button>

	<app-button
		btn="border"
		size="small"
		(click)="openMergedDocumentDialog()"
		[disabled]="highlightedIds.length < 2"
		intercomAttr="documents-merge-button"
	>
		<app-icon [icon]="ICON.COPY" class="mr-1" />
		Merge
		<span *ngIf="highlightedIds.length > 1" class="ml-1"
			>({{ highlightedIds.length }})</span
		>
	</app-button>

	<app-button
		btn="border"
		size="small"
		(click)="print()"
		[disabled]="!highlightedIds.length || selectedDocumentStateLoading"
		[loading]="selectedDocumentStateLoading"
		intercomAttr="documents-print-button"
	>
		<app-icon [icon]="ICON.PRINT" class="mr-1" />
		Print
		<span *ngIf="highlightedIds.length > 1" class="ml-1"
			>({{ highlightedIds.length }})</span
		>
	</app-button>

	<app-button
		btn="border"
		size="small"
		(click)="download()"
		[disabled]="!highlightedIds.length || selectedDocumentStateLoading"
		[loading]="selectedDocumentStateLoading"
		intercomAttr="documents-download-button"
	>
		<app-icon [icon]="ICON.DOWNLOAD" class="mr-1" />
		Download
		<span *ngIf="highlightedIds.length > 1" class="ml-1"
			>({{ highlightedIds.length }})</span
		>
	</app-button>
</ng-template>

<ng-template #tplShowSelectionTip>
	<div class="text-grey text-lg">
		Select one or more documents to
		<b>Merge <app-icon [icon]="ICON.COPY" /></b>,
		<b>Print <app-icon [icon]="ICON.PRINT" /></b> or
		<b>Download <app-icon [icon]="ICON.DOWNLOAD" /></b>
	</div>
</ng-template>
